(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  class ReviewsCarousel {
    constructor(el) {
      this.el         = el;
      this.track      = el.querySelector('.reviews-carousel__track');
      this.cards      = Array.from(el.querySelectorAll('.reviews-carousel__card'));
      this.dotsWrap   = el.querySelector('.reviews-carousel__dots');
      this.prevBtn    = el.querySelector('.rc-arrow--prev');
      this.nextBtn    = el.querySelector('.rc-arrow--next');

      if (!this.track || this.cards.length === 0) return;

      this.autoplay       = el.dataset.autoplay === 'true';
      this.autoplaySpeed  = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
      this.cardsDesktop   = parseInt(el.dataset.cardsDesktop, 10) || 3;
      this.cardsMobile    = parseInt(el.dataset.cardsMobile, 10)  || 1;
      this.currentIndex   = 0;
      this.timer          = null;
      this.isDragging     = false;
      this.dragStart      = 0;
      this.dragCurrent    = 0;

      this._init();
    }

    get cardsVisible() {
      return window.innerWidth >= 768 ? this.cardsDesktop : this.cardsMobile;
    }

    get totalSlides() {
      return Math.max(0, this.cards.length - this.cardsVisible + 1);
    }

    _init() {
      this._buildDots();
      this._update();
      this._bindEvents();
      if (this.autoplay) this._startAutoplay();
    }

    _buildDots() {
      this.dotsWrap.innerHTML = '';
      for (let i = 0; i < this.totalSlides; i++) {
        const dot = document.createElement('button');
        dot.className = 'rc-dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', () => this._goTo(i));
        this.dotsWrap.appendChild(dot);
      }
      this.dots = Array.from(this.dotsWrap.querySelectorAll('.rc-dot'));
    }

    _update() {
      const cardEl    = this.cards[0];
      if (!cardEl) return;

      const style     = getComputedStyle(this.el);
      const gapPx     = parseFloat(style.getPropertyValue('--rc-gap')) || 16;
      const cardW     = cardEl.offsetWidth;
      const offset    = this.currentIndex * (cardW + gapPx);

      this.track.style.transform = `translateX(-${offset}px)`;

      // Dots
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.currentIndex));

      // Arrows
      this.prevBtn.disabled = this.currentIndex === 0;
      this.nextBtn.disabled = this.currentIndex >= this.totalSlides - 1;
    }

    _goTo(index) {
      const max = Math.max(0, this.totalSlides - 1);
      this.currentIndex = Math.min(Math.max(index, 0), max);
      this._update();
    }

    _prev() { this._goTo(this.currentIndex - 1); }
    _next() { this._goTo(this.currentIndex + 1); }

    _startAutoplay() {
      this.timer = setInterval(() => {
        if (this.currentIndex >= this.totalSlides - 1) {
          this._goTo(0);
        } else {
          this._next();
        }
      }, this.autoplaySpeed);
    }

    _stopAutoplay() {
      clearInterval(this.timer);
    }

    _bindEvents() {
      this.prevBtn.addEventListener('click', () => {
        this._stopAutoplay();
        this._prev();
      });

      this.nextBtn.addEventListener('click', () => {
        this._stopAutoplay();
        this._next();
      });

      // Touch / drag
      const stage = this.el.querySelector('.reviews-carousel__stage-wrap');

      const onDragStart = (x) => {
        this.isDragging = true;
        this.dragStart  = x;
        this.dragCurrent = x;
        this._stopAutoplay();
      };
      const onDragMove = (x) => {
        if (!this.isDragging) return;
        this.dragCurrent = x;
      };
      const onDragEnd = () => {
        if (!this.isDragging) return;
        this.isDragging = false;
        const diff = this.dragStart - this.dragCurrent;
        if (Math.abs(diff) > 50) {
          diff > 0 ? this._next() : this._prev();
        }
      };

      stage.addEventListener('mousedown',  (e) => onDragStart(e.clientX));
      window.addEventListener('mousemove', (e) => onDragMove(e.clientX));
      window.addEventListener('mouseup',   ()  => onDragEnd());

      stage.addEventListener('touchstart', (e) => onDragStart(e.touches[0].clientX), { passive: true });
      stage.addEventListener('touchmove',  (e) => onDragMove(e.touches[0].clientX),  { passive: true });
      stage.addEventListener('touchend',   ()  => onDragEnd());

      // Keyboard
      this.el.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft')  { this._stopAutoplay(); this._prev(); }
        if (e.key === 'ArrowRight') { this._stopAutoplay(); this._next(); }
      });

      // Rebuild on resize
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this._buildDots();
          this._goTo(0);
        }, 200);
      });
    }
  }

  // Init all carousels on page
  function initAll() {
    document.querySelectorAll('.reviews-carousel').forEach((el) => {
      if (!el._rcInit) {
        el._rcInit = new ReviewsCarousel(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (e) => {
    const sec = e.target.querySelector('.reviews-carousel');
    if (sec) { sec._rcInit = null; new ReviewsCarousel(sec); }
  });

})();

  } catch(e) { console.error(e); }
})();
})();
